// frontend/src/features/bapb/sections/IncomeAssessorSection.jsx
import React from "react";
import IncomeBasic from "./IncomeBasic";

export default function IncomeAssessorSection(props) {
  // Basic Assessor saves under data.income_assessor
  return <IncomeBasic {...props} dataKey="income_assessor" />;
}
